import { baseApi } from './baseApi';
import { buildRangeQuery } from '../utils/dateRange';

export const metricsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMetrics: builder.query({
      query: () => '/manager/metrics',
      providesTags: [
        { type: 'Subscriber', id: 'LIST' },
        { type: 'Giveaway', id: 'LIST' },
        { type: 'GroupMessage', id: 'LIST' },
      ],
    }),
    getGroupMetrics: builder.query({
      query: (range) => `/manager/groups/metrics?${buildRangeQuery(range)}`,
      providesTags: (result) => [
        { type: 'Group', id: 'LIST' },
        { type: 'Subscriber', id: 'LIST' },
        { type: 'GroupMessage', id: 'LIST' },
        ...(result?.groups ?? []).map((g) => ({ type: 'GroupMessage', id: g.group_id })),
      ],
    }),
    getGroupDeliveryDetails: builder.query({
      query: ({ groupId, channel, range }) =>
        `/manager/groups/${groupId}/deliveries/details?channel=${encodeURIComponent(channel)}&${buildRangeQuery(range)}`,
      providesTags: (result, error, { groupId, channel }) => [
        { type: 'GroupDeliveries', id: `${groupId}-${channel}` },
        { type: 'GroupMessage', id: groupId },
      ],
    }),
    getGroupActiveSubscribers: builder.query({
      query: ({ groupId, range }) => `/manager/groups/${groupId}/subscribers/active?${buildRangeQuery(range)}`,
      providesTags: (result, error, { groupId }) => [
        { type: 'Subscriber', id: `GROUP-ACTIVE-${groupId}` },
        { type: 'GroupMessage', id: groupId },
      ],
    }),
    getSubscriberDeliveryDetails: builder.query({
      query: ({ groupId, subscriberId, range }) =>
        `/manager/groups/${groupId}/subscribers/${subscriberId}/deliveries?${buildRangeQuery(range)}`,
      providesTags: (result, error, { groupId, subscriberId }) => [
        { type: 'Subscriber', id: `DELIVERIES-${subscriberId}` },
        { type: 'GroupMessage', id: groupId },
      ],
    }),
    getAdminMetrics: builder.query({
      query: () => '/admin/metrics',
      providesTags: [
        { type: 'Organization', id: 'LIST' },
        { type: 'User', id: 'LIST' },
        { type: 'Group', id: 'LIST' },
        { type: 'Subscriber', id: 'LIST' },
        { type: 'Giveaway', id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMetricsQuery,
  useGetAdminMetricsQuery,
  useGetGroupMetricsQuery,
  useGetGroupDeliveryDetailsQuery,
  useGetGroupActiveSubscribersQuery,
  useGetSubscriberDeliveryDetailsQuery,
} = metricsApi;
